export default {
  heroSlide1Title: "Accelerare l'assistenza sanitaria dal laboratorio alla vita",
  // heroSlide1Subtitle: "Innovazione farmaceutica leader con oltre 40 anni di competenza in API psicotrope e generici complessi",
  heroSlide2Title: "Portata globale – Clienti in oltre 80 paesi",
  // heroSlide2Subtitle: "Costruire relazioni solide con i principali innovatori farmaceutici e aziende di generici in tutto il mondo",
  heroSlide3Title: "Dai mattoni alle formulazioni: Un partner. Affidabilità totale",
  // heroSlide3Subtitle: "Soluzioni farmaceutiche end-to-end con catena del valore integrata attraverso KSM, API e FDF",
  heroSlide4Title: "6 strutture globali | 4 centri R&S | 1 piattaforma farmaceutica globale",
  // heroSlide4Subtitle: "Infrastruttura di produzione e ricerca di classe mondiale che guida l'innovazione e l'eccellenza della qualità",
  heroSlide5Title: "Le nostre società del gruppo",
  // heroSlide5Subtitle: "Un portafoglio diversificato di aziende che lavorano insieme per fornire soluzioni farmaceutiche complete",
};

